import { Title } from "..";
import { TProductDetail } from "../../../types";
import Container from "../../Container";

const Menu = ({
  title,
  products,
}: {
  title?: string;
  products?: TProductDetail[];
}) => {
  return (
    <section className="w-full mt-10 md:my-5" id="menu">
      <div className="flex items-center justify-center w-full">
        <Title title={title || "SẢN PHẨM"} />
      </div>
      <Container
        className="bg-containerbg"
        col
        scrollOffset={0}
        products={products}
      />
    </section>
  );
};

export default Menu;
